import { render, staticRenderFns } from "./OurSimpleTableHeader.vue?vue&type=template&id=cf2c283a&"
import script from "./OurSimpleTableHeader.vue?vue&type=script&lang=js&"
export * from "./OurSimpleTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./OurSimpleTableHeader.vue?vue&type=style&index=0&id=cf2c283a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports